<template>
  <v-dialog
    v-model="dialog"
    max-width="400"
    persistent
    content-class="rounded-10"
  >
    <v-card class="card-bg rounded-10" v-if="identifications">
      <v-card-title>
        <v-icon color="black" class="mr-1">mdi-account</v-icon>
        SELECT IDENTITY
      </v-card-title>
      <v-card-text>
        <strong>
          {{ identifications.sub }}
        </strong>
        <p>Your login is associated with multiple identities.</p>
        <v-autocomplete
          v-model="identity"
          placeholder="Select an identity to continue..."
          :items="identities"
          outlined
          dense
          class="rounded-lg"
        >
          <template v-slot:item="data">
            <v-icon class="mr-2" v-if="data.item.type === 'client'">
              mdi-office-building
            </v-icon>
            <v-icon class="mr-2" v-if="data.item.type === 'employee'">
              mdi-account
            </v-icon>
            <v-icon class="mr-2" v-if="data.item.type === 'partner'">
              mdi-handshake
            </v-icon>
            {{ data.item.text }}
          </template>
        </v-autocomplete>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { prettyIDName } from "@/utils"
import { mapGetters, mapActions } from "vuex"

export default {
  name: "IdentificationSelector",

  props: ["value"],

  data() {
    return {
      identity: null,
      actorTypePriority: {
        employee: 0,
        partner: 1,
        client: 2
      }
    }
  },

  watch: {
    identity(value) {
      if (!value) return

      this.setIdentity(value)
    }
  },

  computed: {
    ...mapGetters(["identifications"]),

    dialog: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit("input", value)
      }
    },

    identities() {
      const ids = this.identifications.actors.map((id) => {
        return {
          text: prettyIDName(id),
          value: id.uid,
          type: id.actor_type
        }
      })

      return ids.sort((a, b) => {
        const typeDiff =
          (this.actorTypePriority[a.type] ?? 1) -
          (this.actorTypePriority[b.type] ?? 1)

        if (typeDiff !== 0) {
          return typeDiff
        }

        return a.text.localeCompare(b.text, undefined, {
          sensitivity: "base"
        })
      })
    }
  },

  methods: {
    ...mapActions(["setSelectedIdentity", "setCountry"]),

    setIdentity(value) {
      this.setSelectedIdentity(value)
      const id = this.identifications.actors.find((id) => id.uid === value)
      this.setCountry(id.payload.country)
      this.dialog = false
    }
  }
}
</script>
